<template>
  <transition :name="disableTransitions ? '' : 'mc-zoom-in-center'">

    <div
      class="mc-tag"
      :class="[
        type ? 'mc-tag--' + type : '',
        tagSize && `mc-tag--${tagSize}`,
        {'is-hit': hit}
      ]"
      @click="handleClick"
      :style="{backgroundColor: color}">
      <span class="mc-tag__prepend" v-if="(typeof prepend === 'number' || typeof prepend === 'string')" v-text="prepend"></span>
      <slot></slot>
      <i class="mc-tag__close fa fa-close-custom"
        v-if="closable"
        @click.stop="handleClose"></i>
    </div>
  </transition>
</template>
<script>
  export default {
    name: 'McTag',
    props: {
      text: {
          type: String,
          default: ''
      },
      closable: Boolean,
      type: String,
      hit: Boolean,
      disableTransitions: Boolean,
      color: String,
      size: String,
      prepend: [Number, String]
    },
    methods: {
      handleClose(event) {
        this.$emit('close', event);
      },
      handleClick(event) {
        this.$emit('click', event);
      }
    },
    computed: {
      tagSize() {
        return this.size || (this.$ELEMENT || {}).size;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/tag.vue